import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b6cc9bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-center justify-between hidden w-full h-16 bg-gray-100 lg:flex" }
const _hoisted_2 = { class: "container flex items-center justify-between" }
const _hoisted_3 = { class: "px-5 py-2" }
const _hoisted_4 = {
  href: "#/scorecards",
  rel: "home"
}
const _hoisted_5 = { class: "flex justify-between px-5 py-2" }
const _hoisted_6 = { class: "relative flex items-center justify-between w-full h-16 bg-gray-100 lg:hidden" }
const _hoisted_7 = { class: "flex items-center w-full px-5 py-2 gap-x-10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "flex items-center justify-center w-full" }
const _hoisted_13 = {
  href: "#/scorecards",
  rel: "home"
}
const _hoisted_14 = { class: "flex justify-between w-full px-4" }
const _hoisted_15 = {
  href: "#/scorecards",
  rel: "home"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-4 h-0.5 bg-gray-400 rounded" }, null, -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "flex flex-col h-full mt-5 gap-y-5" }

import Version from '@/components/UI/Version.vue';
import router from '@/router';
import { useUserStore } from '@/store/users';
import { NavigationItem } from '@/typings/navigation';
import { ref } from 'vue';
import NavLink from './NavLink.vue';
import Logo from '../UI/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

const menuItems = ref<NavigationItem[]>([
  {
    label: 'pws.com',
    requiresLogin: false,
    adminOnly: false,
    alwaysVisible: true,
    external: true,
    route: 'https://prowrestlingscorecards.com/',
  },
  {
    label: 'Cards',
    requiresLogin: false,
    adminOnly: false,
    alwaysVisible: true,
    route: '/scorecards',
  },
  {
    label: 'Factions',
    requiresLogin: false,
    adminOnly: false,
    alwaysVisible: true,
    route: '/factions',
  },
  {
    label: 'Account',
    requiresLogin: true,
    adminOnly: false,
    alwaysVisible: false,
    route: '/account',
  },
  {
    label: 'Data Management',
    requiresLogin: true,
    adminOnly: true,
    alwaysVisible: false,
    route: '/data',
  },
  {
    label: 'Log Out',
    requiresLogin: true,
    adminOnly: false,
    alwaysVisible: false,
    action: async () => {
      await userStore.logout();
      router.push('/login');
    },
  },
  // {
  //   label: 'Sign Up',
  //   requiresLogin: false,
  //   adminOnly: false,
  //   alwaysVisible: false,
  //   route: '/new-user',
  // },
  {
    label: 'Sign In',
    requiresLogin: false,
    adminOnly: false,
    alwaysVisible: false,
    route: '/login',
  },
  {
    label: 'Feedback',
    requiresLogin: false,
    adminOnly: false,
    alwaysVisible: true,
    external: true,
    route: 'mailto:feedback@prowrestlingscorecards.com',
  },
]);

const showMobileNav = ref(false);
function toggleMobileNav() {
  showMobileNav.value = !showMobileNav.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createVNode(Logo, { class: "w-36" })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
            return (_openBlock(), _createBlock(NavLink, {
              key: item.label,
              class: "text-sm",
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          onClick: toggleMobileNav,
          class: "cursor-pointer absolute space-y-1.5 handle left-1 border border-transparent hover:border-gray-200 rounded p-3"
        }, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", _hoisted_13, [
            _createVNode(Logo, { class: "w-36" })
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      onClick: toggleMobileNav,
      class: "absolute top-0 bottom-0 left-0 right-0 z-40 bg-gray-500 bg-opacity-50"
    }, null, 512), [
      [_vShow, showMobileNav.value]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["absolute top-0 bottom-0 z-50 flex flex-col h-full px-4 py-3 bg-gray-100 slide w-96", {
      'slide-in': showMobileNav.value,
      'slide-out': !showMobileNav.value,
    }])
    }, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", _hoisted_15, [
          _createVNode(Logo, { class: "w-36" })
        ]),
        _createElementVNode("div", {
          onClick: _withModifiers(toggleMobileNav, ["stop"]),
          class: "cursor-pointer space-y-1.5 handle top-3 left-1 border border-transparent hover:border-gray-200 rounded p-3"
        }, _hoisted_20, 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
          return (_openBlock(), _createBlock(NavLink, {
            key: item.label,
            class: "text-xl",
            item: item,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileNav.value = false))
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _createVNode(Version)
    ], 2)
  ], 64))
}
}

})